module.exports = __webpack_public_path__ + "img/box-open.aec62e9e.svg";